import { useClientPortalSelector, selectBooking, selectBookingType } from "../../../../../redux";
import { STEP_AVAILABILITY, StepId } from "../../../bookingSlice.types";
import SummaryItem from "../SummaryItem";
import { BookingType } from "types/appointmentBooking";
import { useClientPortalConfigContext } from "../../../../../context";
import { getGroupBookingLabel } from "../../../../../utils/groupBookingLabel";

export interface IStep {
    name: string;
    value: StepId;
}

export interface ISummaryStepsProps {
    handleStepClick: (step: StepId) => void;
    steps: Array<IStep>;
    getDisplayText: (stepId: StepId) => string | null;
}

export default function SummarySteps({ handleStepClick, steps, getDisplayText }: Readonly<ISummaryStepsProps>) {
    const booking = useClientPortalSelector(selectBooking);
    const bookingType = useClientPortalSelector(selectBookingType);
    const {
        clientPortalConfig: { groupBookingLabel },
    } = useClientPortalConfigContext();
    const shouldShowGroup = bookingType === BookingType.CLASS && booking.group.data?.groupName;
    const configuredGroupBookingLabel = getGroupBookingLabel(groupBookingLabel);

    return (
        <>
            {steps.map((stepKey) => {
                const displayText = getDisplayText(stepKey.value);

                if (!displayText) {
                    return null;
                }

                if (displayText === "See availability for all Providers" || displayText === "Logged in") {
                    return null;
                }

                return (
                    <SummaryItem
                        key={stepKey.value}
                        dataTestIdSuffix={stepKey.value}
                        title={stepKey.name}
                        content={displayText}
                        onClick={() => handleStepClick(stepKey.value)}
                    />
                );
            })}

            {shouldShowGroup && (
                <SummaryItem
                    dataTestIdSuffix="group"
                    title={configuredGroupBookingLabel}
                    content={booking.group.data.groupName}
                    onClick={() => handleStepClick(STEP_AVAILABILITY)}
                />
            )}
        </>
    );
}
